export default __webpack_public_path__ + "static/media/Resource-Icons-Developmental-Challenges-transparent.f46a0f6c.png";